var map = {
	"./bkg-down.svg": 5222,
	"./bkg-up.svg": 3565,
	"./bkg.svg": 4025,
	"./cosmo-hotel-img.png": 7465,
	"./edenred-logo.svg": 5038,
	"./footer-bkg.svg": 6793,
	"./fronte-1.jpg": 7811,
	"./header-bkg.png": 2939,
	"./home-img-1.png": 4410,
	"./home-img-2.png": 4993,
	"./home-img-3.png": 3864,
	"./home-img-4.png": 6503,
	"./home-img-5.png": 7278,
	"./homepage-img-main.jpg": 9323,
	"./homepage-img-main.png": 7907,
	"./icon-area-personale.png": 6686,
	"./icon-contacts.png": 472,
	"./icon-dress.png": 1902,
	"./icon-foto-e-video.png": 1001,
	"./icon-home.png": 7690,
	"./icon-news.png": 6317,
	"./icon-program.png": 8859,
	"./mood-img.png": 4864,
	"./news-star-aggiornamento.svg": 4807,
	"./news-star-evento.svg": 9259,
	"./news-star-travel.svg": 6448,
	"./news_icon.svg": 7074,
	"./programma-giorno-1.jpg": 2672,
	"./programma-giorno-2.jpg": 47,
	"./programma-giorno-3.jpg": 8338,
	"./qr_dummy.jpg": 2659,
	"./retro.jpg": 1395,
	"./retro.png": 5131,
	"./teams-bkg.png": 8794,
	"./weareone-logo.svg": 6483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;